export function isValidEmail(email) {
  // Simple email pattern; adjust as needed for more strict validation
  const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return pattern.test(email);
}
